module.exports = __webpack_public_path__ + "static/img/ProcessFlowProject.a5dce1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ProcessFlowProject.png
// module id = QklF
// module chunks = 62